import { useState, useRef, RefObject } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { useIsomorphicLayoutEffect } from '../../hooks/useIsomorphicLayoutEffect';
import { debounce } from '../../_internal_/utils/delay';

/**
 * Хук для отслеживания размеров элемента
 */

export const useResizeObserver = ({
  ref,
  debounceDelay = 0
}) => {
  const animationFrameRef = useRef(NaN);
  const [size, setSize] = useState({
    width: NaN,
    height: NaN
  });
  const debouncedCallback = debounce(value => setSize(value), debounceDelay);
  useIsomorphicLayoutEffect(() => {
    const element = ref.current;
    if (!element || typeof window === 'undefined') {
      return;
    }
    const resizeObserver = new ResizeObserver(entries => {
      animationFrameRef.current = window.requestAnimationFrame(() => {
        if (!Array.isArray(entries) || !entries.length) {
          return;
        }
        const entry = entries[0];
        const width = Math.round(entry.contentRect.width);
        const height = Math.round(entry.contentRect.height);
        debouncedCallback({
          width,
          height
        });
      });
    });
    resizeObserver.observe(element);
    return () => {
      window.cancelAnimationFrame(animationFrameRef.current);
      resizeObserver.unobserve(element);
    };
  }, [ref]);
  return size;
};